import { TASK_BAMBOU_LIST_FAIL, TASK_BAMBOU_LIST_REQUEST, TASK_BAMBOU_LIST_SUCCESS, TASK_RAMBO_LIST_FAIL, TASK_RAMBO_LIST_REQUEST, TASK_RAMBO_LIST_SUCCESS } from "../constats/task.constant";

export const taskRambosListReducer = (state={}, action) => {
    switch (action.type) {
        case TASK_RAMBO_LIST_REQUEST:
            return {
                loading: true
            };
        case TASK_RAMBO_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case TASK_RAMBO_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}

export const taskBambousListReducer = (state={}, action) => {
    switch (action.type) {
        case TASK_BAMBOU_LIST_REQUEST:
            return {
                loading: true
            };
        case TASK_BAMBOU_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case TASK_BAMBOU_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}